import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';

import {catchError, concatMap, map, switchMap, withLatestFrom} from 'rxjs/operators';
import {EMPTY, of} from 'rxjs';
import { PlanMgtActionTypes, PlanMgtActions } from '../actions/plan-mgt.actions';
import {PlanService} from '../../../services/plan.service';
import * as fromStore from '../../../store';
import {Store} from '@ngrx/store';
import * as featureActions from '../../index';
import {updateInfoType} from '../../../shareModel';
import {UpdateInfoModel} from '../../updateInfo/update-info.model';


@Injectable()
export class PlanMgtEffects {
  private actions$ = inject(Actions);
  private store$ = inject(Store<fromStore.State>);
  private planService = inject(PlanService);

  constructor() {}

  GetPlanMgts$ = createEffect(() => this.actions$.pipe(
    ofType(PlanMgtActionTypes.GetPlanMgts),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([action, user]: [any, any]) => {
      const params = {
        otp: (action.payload && action.payload.otp) ? action.payload.otp : user.otp
      };
      return this.planService.ReadPlanManagement(params).pipe(
        switchMap((res: any) => {
          if (res.result && res.msg.body && Array.isArray(res.msg.body) && res.msg.body.length > 0) {
            if (action.payload && !action.payload.syncAccountsInfo) {
              return [new featureActions.LoadPlanMgts(res.msg.body)];
            } else {
              return [new featureActions.LoadPlanMgts(res.msg.body), new featureActions.GetAccounts()];
            }
          } else {
            return [new featureActions.LoadPlanMgts([])];
          }
          // throw new Error('update fail');
        }),
        // TODO: catchError Message調整 --> 留待未來再回頭定義Error Message
        catchError(error => {
          return of(new featureActions.GetPlanMgtsFail());
        })
      );
    })
  ));
  GetUpdatePlanMgts$ = createEffect(() => this.actions$.pipe(
    ofType(PlanMgtActionTypes.GetUpdatePlanMgts),
    map((action: featureActions.GetUpdatePlanMgts) => action.payload),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([payload, user]) => {
      const params = {
        otp: user.otp,
        Plans: payload
      };
      return this.planService.UpdatePlanManagement(params).pipe(
        switchMap((res: any) => {
          const result = { ...res, type: updateInfoType.EditPlanMgt };
          if (result.result) {
            const getPlanMgtParam = {syncAccountsInfo: true};
            return [new featureActions.GetPlanMgts(getPlanMgtParam), new featureActions.UpdateInfoSuccessAction(result)];
          }
          throw new Error('update fail');
        }),
        // TODO: catchError Message調整 --> 已完成
        catchError(error => {
          const res: UpdateInfoModel = {
            result: false,
            errmsg: 'Error',
            type: updateInfoType.EditPlanMgt
          };
          return [new featureActions.GetPlanMgtsFail(), new featureActions.UpdateInfoFailAction(res)];
        })
      );
    })
  ));




}
